import styled from 'styled-components';

export const MainBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-top: 5%;
`;

export const ImageContainer = styled.div`
   ;
`;
export const SubContent = styled.div``;
export const ShellHeader = styled.div`
  display: block;
  margin-left: 0.5rem;
  font-weight: bold;
  margin-bottom: 0.2rem;
`;

export const ShellFooter = styled.div`
  margin-left: 0.5rem;
`;

export const ShellLogoContainer = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
`;

export const StatusCode = styled.div`
  margin-bottom: 0.25rem;
  font-size: 1.5em;
  color: #d9d9d9;
`;

export const UserMessage = styled.div`
  color: #d9d9d9;
`;

export const ColouredLink = styled.a`
  color: white;
`;

export const CenteredMessage = styled.div`
  text-align: center;
  font-size: 1.25em;
  margin-bottom: 1rem;
`;

export const BoldCenteredText = styled.div`
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const CenteredRolesList = styled.ul`
  padding-left: 0;
  text-align: center;
  margin: 0;
`;

export const RoleItem = styled.li`
  text-align: center;
  font-size: 0.85em;
  list-style: none;
`;
